export default {
  name: 'zhuzhou',
  adcode: '430200',
  mapName: '株洲市',
  geoJsonPath: 'hunanmap/430200.json',
  backgroundImage: {
    png: '株洲市_430200.png',
    webp: '株洲市_430200.webp'
  },
  echartsMapStyle: {
    width: '598px',
    height: '750px',
    marginTop: 'auto',
    marginBottom: '25px',
  },
  imageSize: {
    width: 2760,
    height: 3462
  },
  // 地图特殊配置：背景图片适配参数
  specialConfig: {
    // 独立调整参数
    layoutSizeAdjustment: {
      enabled: true,
      multiplier: 0.98, // 布局尺寸调整倍数（微调）
      minSize: 400,     // 最小布局尺寸
      maxSize: 1200     // 最大布局尺寸
    },
    aspectScaleAdjustment: {
      enabled: true,
      multiplier: 1.02, // 宽高比调整倍数（微调）
      minScale: 0.5,    // 最小缩放比例
      maxScale: 2.0     // 最大缩放比例
    },
    // 位置偏移补偿
    positionOffset: {
      x: 0.005,  // X轴偏移百分比
      y: 0.004  // Y轴偏移百分比
    }
  },
  // 区县列表
  districts: ['株洲市区', '渌口区', '攸县', '茶陵县', '炎陵县', '醴陵市'],
  // 区县坐标映射（用于tooltip定位与涟漪效果）
  cityCoords: {
    '株洲市区': [112.9430, 27.7460],
    '株洲市': [112.9430, 27.7460],
    '渌口区': [113.0040, 27.3490],
    '攸县': [113.4230, 27.2000],
    '茶陵县': [113.6590, 26.8490],
    '炎陵县': [113.9520, 26.5090],
    '醴陵市': [113.2560, 27.6260]
  },
  // 区县名称标准化
  normalizeName: (name) => {
    if (!name) return ''
    const s = String(name).trim()
    if (s === '株洲市') return '株洲市区'
    return s
  },
  // 区县与adcode映射
  cityAdcodeMap: {
    '荷塘区': '430202',
    '芦淞区': '430203',
    '石峰区': '430204',
    '天元区': '430211',
    '渌口区': '430212',
    '攸县': '430223',
    '茶陵县': '430224',
    '炎陵县': '430225',
    '醴陵市': '430281'
  }
}